export default __webpack_public_path__ + "static/service-2-509841badcefd23f12d2e0eed1ddeff9.jpg";